





















































































































































































































































































































































































































































































































































import Vue from 'vue';
import API from '@/api/common';
import * as validation from '@/class/common/validation';
import * as models from '@/class/models/views/contact';
import NOC from '@/class/common/const';
import * as NOCArray from '@/personal/array';
import SendErrorModal from './SendErrorModal.vue';
import SERVICE, { metaInfo } from '.';
import { makeTrialEndDateStr, TRIAL_PERIOD_MONTH } from '@/class/common/util/trial';

// 無料お試し期間の文字列
const STR_SAMPLE_TRIAL_PERIOD_START = "6/15";
const STR_SAMPLE_TRIAL_PERIOD_END = makeTrialEndDateStr(STR_SAMPLE_TRIAL_PERIOD_START);

export default Vue.extend({
  name: 'ServiceContact',
  metaInfo: metaInfo({
    title: 'FAQ・お問い合わせ｜ RemoLabo ｜ リモートワーク・テレワークの勤怠管理ツール',
    meta: [
      { name: 'description', content: 'リモートワーク・テレワークの勤怠管理ツール「RemoLabo（リモラボ）」FAQ・お問い合わせのページです。お客様よりいただいたご質問をまとめています。お探しの内容が見つからない場合には、問い合わせフォームよりお気軽にお問い合わせください。' },
      { property: 'og:title', content: 'FAQ・お問い合わせ - RemoLabo | リモートワーク・テレワークの勤怠管理・生産性分析ツール' },
      { property: 'og:description', content: 'お客さまよりいただいたご質問をまとめました。お探しの内容が見つからない場合には、問い合わせフォームよりお気軽にお問い合わせください。' },
      { property: 'og:url', content: 'https://remolabo.net/service/contact/' },
    ],
    link: [
      { rel: 'canonical', href: '/service/contact' },
    ],
  }),
  components: {
    SendErrorModal,
  },
  data() {
    return {
      service: new SERVICE(),
      // header
      activeSpMenu: false,
      // FAQ
      showEnvironment: false,
      showCalculate: false,
      showTrialPlan: false,
      showCost: false,
      showMinimum: false,
      showManual: false,
      // form
      isSent: false,
      isSendError: false,
      company: '',
      name: '',
      mail: '',
      category: 0,
      content: '',
      errorCompany: '',
      errorName: '',
      errorMail: '',
      errorCategory: '',
      errorContent: '',
      isProcessing: false, // 二重サブミット防止用
    };
  },
  computed: {
    CONTACTS() {
      return [NOC.SELECT.NOSELECT_LONG].concat(NOCArray.CONTACT);
    },
    TRIAL_PERIOD_MONTH(){ return TRIAL_PERIOD_MONTH; },
    STR_SAMPLE_TRIAL_PERIOD_START(){ return STR_SAMPLE_TRIAL_PERIOD_START; },
    STR_SAMPLE_TRIAL_PERIOD_END(){ return STR_SAMPLE_TRIAL_PERIOD_END; },
  },
  mounted() {
    this.service.mountedProcess();
    // ページ内リンク
    let hash = this.$route.hash;
    if (hash) {
      hash = hash.substring(1, hash.length);
      const target = document.getElementById(hash);
      if (target) {
        target.scrollIntoView();
      }
    }
  },
  destroyed() {
    this.service.destroyProcess();
  },
  methods: {
    // FAQ open
    toOpen(el: any) {
      const padding = window.matchMedia('(max-width: 650px)').matches ? 30 : 35;
      el.style.height = el.scrollHeight + padding + 'px';
    },
    // FAQ close
    toClose(el: any) {
      el.style.height = '0';
    },
    // 問い合わせ送信
    async onSubmit() {
      // 入力チェック
      const noinput = '未入力です。';
      // this.errorCompany = this.company ? '' : noinput;
      this.errorName = this.name.trim() ? '' : noinput;
      this.errorCategory = this.category ? '' : noinput;
      // content
      if (this.content.trim()) {
        if (this.content.length <= 500) {
          this.errorContent = '';
        } else {
          this.errorContent = '500文字以内で入力してください。';
        }
      } else {
        this.errorContent = noinput;
      }
      // mail
      if (this.mail) {
        if (validation.REGDIG.email.test(this.mail)) {
          this.errorMail = '';
        } else {
          this.errorMail = 'メールアドレスの形式ではありません。';
        }
      } else {
        this.errorMail = noinput;
      }
      // 入力エラーが1つでもあれば送信しない
      if (this.errorName || this.errorCategory || this.errorContent || this.errorMail) {
        return;
      }
      // 送信処理
      const reqData: models.IServiceContact = {
        company: this.company,
        name: this.name,
        mail: this.mail,
        category: this.category,
        content: this.content,
        regist: false,
      };
      this.isProcessing = true;
      const api = new API();
      const res = await api.post<models.IServiceContact, {deneid: boolean}>('contact/service', reqData);
      if (res.result) {
        this.isSent = true;
      } else {
        this.isSendError = true;
      }
      this.isProcessing = false;
    },
  },
});
